"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=e(require("styled-components")).default.section`
    margin: 97px 0 95px;
    .inner {
        display: grid;
        margin: 0 auto;
        max-width: 512px;
        padding: 0 25px;
        row-gap: 50px;
        @media screen and (min-width: 992px) {
            grid-template-columns: repeat(3, 1fr);
            gap: 0 28px;
            max-width: 1224px;
            padding: 0 25px;
        }
    }
    .info-blurb {
        display: grid;
        grid-template-columns: 54px 1fr;
        column-gap: 30px;
        @media screen and (min-width: 992px) {
            column-gap: 37px;
        }
    }
    .info-blurb-icon {
        align-items: center;
        border-radius: 9px;
        display: flex;
        height: 54px;
        justify-content: center;
        overflow: hidden;
        position: relative;
        div {
            align-items: center;
            display: flex;
            height: 65%;
            width: 100%;
            svg {
                margin: 0 auto;
                height: 100%;
                width: 100%;
                path {
                    fill: currentColor;
                }
            }
            &::after {
                content: '';
                height: 100%;
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background: currentColor;
                opacity: 0.1;
            }
        }
    }
    .DXInfoBlurb-header {
        font-size: 18px;
        letter-spacing: -0.3px;
        line-height: 24px;
        margin: -5px 0 0;
        @media screen and (min-width: 992px) {
            font-size: 20px;
        }
    }
    .DXInfoBlurb-content {
        font-size: 16px;
        letter-spacing: normal;
        line-height: 27px;
        margin: 5px 0 11px;
    }
    .DXInfoBlurb-link {
        border-radius: 2px;
        font-family: ${({theme:e})=>e.fonts.secondary.fontFamily};
        font-size: 12px;
        font-weight: 700;
        line-height: 15px;
        letter-spacing: normal;
        outline: none;
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
